import { gql } from "@apollo/client";

export const GET_MASTER_DATA_DISTRIBUTION_CENTERS = gql`
  query MasterDataDistributionCenters(
    $params: MasterDataDistributionCentersParamsInput!
  ) {
    masterDataDistributionCenters(params: $params) {
      total
      page
      limit
      items {
        distributionCenterId
        purchaserId
        dcCode
        dcName
        createdAt
        purchaserName
        purchaserKey
      }
    }
  }
`;
